function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.8365 7.50033L12.0289 10.6363C10.9163 11.879 10.3601 12.5003 9.62821 12.5003C8.89638 12.5003 8.34009 11.879 7.22752 10.6363L6.50321 9.82729M19.0032 10.0003C19.0032 14.6027 15.2723 18.3337 10.6699 18.3337C6.06751 18.3337 2.33655 14.6027 2.33655 10.0003C2.33655 5.39795 6.06751 1.66699 10.6699 1.66699C15.2723 1.66699 19.0032 5.39795 19.0032 10.0003Z",
    stroke: "#F6F6F6",
    style: {
      stroke: "#F6F6F6",
      stroke: "color(display-p3 0.9649 0.9649 0.9649)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/activeIcon.c5d55957e07f10a5a70ed299c21753df.svg";
export { ForwardRef as ReactComponent };